import * as Yup from 'yup';

export const filterSchema = values => Yup.object().shape({
    project: Yup.string(),
    district: Yup.string(),
    dorms: Yup.string(),
    vista: Yup.string(),
    range_price: Yup.string(),
});
